import React from 'react';
import { GENERAL_ID } from '../components/Stores/exposureDataStore';
import { useMaterialsStore } from '../components/Stores/MaterialsStore';
import { Material } from '../sp-types';

const currencyMap: Record<string, string> = {
  USD: '$',
  'CNY=': '¥',
  EUR: '€',
  GBP: '£',
  TEU: ' ',
  ILS: '₪',
  MYR: 'RM',
};

const currencies = Object.keys(currencyMap).filter((cur) => cur !== 'TEU');
export const getCurrencySymbol = (currency: string): string => currencyMap[currency] || '$';
export const CNY = 'CNY=';
export const EUR = 'EUR=';
export const GBP = 'GBP=';

export function useCurrencyRates() {
  const { materialsMap } = useMaterialsStore();

  const yuanToUsd = materialsMap[CNY]?.currentPrice || 1;
  const eurToUsd = materialsMap[EUR]?.currentPrice || 1;
  const gbpToUsd = materialsMap[GBP]?.currentPrice || 1;
  const ilsToEUR = materialsMap['EURILS=']?.currentPrice || 1;
  const ilsToUsd = materialsMap['ILS=']?.currentPrice || 1;
  const myrToUsd = materialsMap['MYR=']?.currentPrice || 1;

  const getCurrencyRate = (mat: Material): number => getCurrencyInUSD(mat?.currency || 'USD');

  const getCurrencyInUSD = (currency: string): number =>
    currency === CNY
      ? 1 / yuanToUsd
      : currency === EUR.replace('=', '')
      ? eurToUsd
      : currency === GBP.replace('=', '')
      ? gbpToUsd
      : currency === 'ILS'
      ? 1 / ilsToUsd
      : currency === 'MYR'
      ? 1 / myrToUsd
      : 1;

  const pricesMap: Record<string, number> = React.useMemo(() => {
    return Object.fromEntries(
      Object.entries(materialsMap).map(([key, material]) => [key, material.currentPrice * getCurrencyRate(material)]),
    );
  }, [materialsMap]);

  const convertionMap: Record<string, number> = Object.fromEntries([
    ...Object.entries(materialsMap).map(([key, material]) => [key, getCurrencyRate(material)]),
    [GENERAL_ID, 1],
  ]);
  return { getCurrencyRate, getCurrencySymbol, CNY, EUR, pricesMap, convertionMap, currencies, getCurrencyInUSD };
}
